export default __webpack_public_path__ + "static/media/langIcon.90e61ff2.svg";